module.exports = __webpack_public_path__ + "static/media/hollow-check.9adde47d.svg";